import { z } from 'zod';
import { BrandTranslation } from './BrandTranslation';

export const Brand = z.object({
  id: z.coerce.number(),
  brandId: z.coerce.number(),
  translations: z
    .array(BrandTranslation)
    .optional()
    .transform((translations) => {
      if (!translations) return undefined;
      return translations.reduce<Record<string, BrandTranslation>>((acc, translation) => {
        acc[translation.locale] = translation;
        return acc;
      }, {});
    }),
  logoUrl: z.string().nullable().optional(),
  pinUrl: z.string().nullable().optional(),
  priority: z.coerce.number().optional(),
});

export type Brand = z.infer<typeof Brand>;
